import { render, staticRenderFns } from "./Workspaces.vue?vue&type=template&id=523b6b78&scoped=true"
import script from "./Workspaces.vue?vue&type=script&lang=js"
export * from "./Workspaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b6b78",
  null
  
)

export default component.exports